require('../../modules/es6.object.keys');
module.exports = require('../../modules/$.core').Object.keys;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/keys.js
 ** module id = 484
 ** module chunks = 0
 **/